import GeoDistribution from './GeoDistribution';

export default GeoDistribution;
